export default __webpack_public_path__ + "static/media/parentAndChildBundle.ed96068a.png";